/**
 * Баннер «подтверди почту» с цветовыми состояниями ok / error / pending.
 */

import { useTranslation } from "react-i18next";

export type VerifyBannerState = "pending" | "ok" | "error";

export interface VerifyBannerProps {
  readonly state: VerifyBannerState;
  readonly messageKey?: string | undefined;
  readonly onResend: () => void;
  /** Закрыть баннер. Вернуть его можно кнопкой в настройках. */
  readonly onDismiss: () => void;
}

export function VerifyBanner({
  state,
  messageKey,
  onResend,
  onDismiss,
}: VerifyBannerProps): React.JSX.Element {
  const { t } = useTranslation(["common", "errors"]);

  const text =
    messageKey !== undefined && messageKey !== null
      ? t(messageKey, { defaultValue: messageKey })
      : t("auth.verify_pending");

  return (
    <div className="verify-banner" data-state={state} role="status">
      <span className="verify-banner__icon" aria-hidden="true">
        {state === "ok" ? (
          <svg viewBox="0 0 24 24" width="16" height="16">
            <path d="M5 12.5 10 17.5 19 7.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
          </svg>
        ) : state === "error" ? (
          <svg viewBox="0 0 24 24" width="16" height="16">
            <path d="M12 8v5M12 16h.01" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="16" height="16">
            <path d="M4 6h16v12H4z" fill="none" stroke="currentColor" strokeWidth="1.8" />
            <path d="m4 7 8 6 8-6" fill="none" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        )}
      </span>
      <p>{text}</p>
      {state === "pending" && (
        <button type="button" className="button verify-banner__resend" onClick={onResend}>
          {t("auth.verify_resend")}
        </button>
      )}
      <button
        type="button"
        className="verify-banner__dismiss"
        onClick={onDismiss}
        title={t("auth.verify_dismiss")}
        aria-label={t("auth.verify_dismiss")}
      >
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
          <path
            d="M6 6l12 12M18 6L6 18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}
